import request from '@/utils/request'

export function getData(params) {
  return request({
    url: '/history_summary/max_cost_last_ten_days',
    method: 'get',
    params
  })
}

export function getmaterialData(params) {
  return request({
    url: '/history_summary/video_material_bind',
    method: 'get',
    params
  })
}
